import * as yup from 'yup';

export type CreateNoteSchemaType = {
  text: string;
};

export const createNoteSchema: yup.SchemaOf<CreateNoteSchemaType> = yup.object({
  text: yup.string().required(),
});
